import * as React from 'react';
import styled from 'styled-components';
import { StretchMidPageCompaignContainer, Container } from '../Container';
import { CardBlockContainer } from '../Card/CardBlockContainer';
import { MidPageCampaign } from '../MidpageCampaign';
import { ProofPoints } from '../ProofPoints';
import { getExperienceOffer } from '../../utils/utils';
import { mboxes } from '../../consts/mboxes';

export const WhyOriginContainer = styled(Container)`
  padding: 40px 0;
`;

export const CustomerExperience = ({ store, experienceContent }) => {
  const topCardContent = getExperienceOffer(mboxes.topCardsMbox);
  return (
    <>
      <WhyOriginContainer>
        <ProofPoints {...experienceContent} />
      </WhyOriginContainer>
      {store.content.midpagecampaign && (
        <StretchMidPageCompaignContainer>
          <MidPageCampaign {...store.content.midpagecampaign} />
        </StretchMidPageCompaignContainer>
      )}
      <CardBlockContainer
        {...store.content.topcard}
        {...topCardContent}
        trackingPrefix="cardTop"
        data-comment="CardTop"
      />
      {store.content.bottomcard && (
        <CardBlockContainer
          trackingPrefix="cardBottom"
          data-comment="CardBottom"
          {...store.content.bottomcard}
        />
      )}
    </>
  );
};
